<template>
  <alert-card display="three-line-heading" middleHeading="All caught up!">
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
export default {
  components: { AlertCard },
};
</script>
